// ========== PhilosophyPage.jsx ==========
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';
import AdUnit from '../components/AdUnit';
import AdRotator from '../components/AdRotator';

const PhilosophyPage = () => {
  const navigate = useNavigate();

  return (
    <div className="static-page">
      <header className="static-header">
        <nav className="static-nav">
          <div className="logo" onClick={() => navigate('/')}> Mellodai</div>
          <a onClick={() => navigate('/')}> Back to Home</a>
        </nav>
      </header>
      {/* Place the AdUnit adsense component here */}
      <section className="headerAd">
        <AdRotator floating={true} placement="sidebar" />
       {/* <AdUnit adSlot="8074484061" />*/}
      </section>
      <div className="content-container">
        <div className="hero" style={{padding: '80px 2rem 40px', marginTop: 0}}>
          <h1> The Philosophical Divide</h1>
          <p>Why AI Prediction Triumphs Over Tarot and Horoscopes</p>
        </div>

        <div className="content-section">
          <p>For millennia, humans have sought to decode the future through mysticism. While these methods fulfill a psychological need for guidance, they operate in the realm of the subjective and symbolic.</p>
          <p>Today, AI and Big Data offer a radically different, demonstrably more reliable path to forecasting: one rooted in science, probability, and empirical evidence.</p>
        </div>

        <div className="content-section">
          <h2> The Mystical Approach</h2>
          <p>Tarot and horoscopes belong to pseudoscience�practices that claim to be scientific but lack evidence and testability.</p>
          <ul>
            <li><strong>Mechanism:</strong> Based on planetary alignment and card symbolism with no proven causality</li>
            <li><strong>Data Source:</strong> Ancient texts and subjective interpretation - vague and untestable</li>
            <li><strong>Output:</strong> Symbolic narratives that are highly subjective</li>
          </ul>
          <p style={{marginTop: '1rem', fontStyle: 'italic'}}>The inherent problem: They offer a narrative, not a prediction. No predictive power for measurable, real-world events.</p>
        </div>

        <div className="content-section">
          <h2> The Data-Driven Approach</h2>
          <p>AI forecasting represents the modern evolution of the scientific method applied to human life.</p>
          <ul>
            <li><strong>Mechanism:</strong> Algorithms and Machine Learning that calculate verifiable patterns</li>
            <li><strong>Data Source:</strong> Massive, real-world datasets of millions of anonymized human events</li>
            <li><strong>Output:</strong> Calculated probability�statistically informed likelihood that's objective</li>
          </ul>
          <p style={{marginTop: '1rem'}}><strong>The AI Difference:</strong> AI offers a statistical edge, translating chaos into actionable probabilities.</p>
        </div>

        <div className="content-section">
          <h2> Why Choose Data Over Divination</h2>
          <ul>
            <li><strong>Risk Mitigation:</strong> Quantified insights into risks associated with major decisions</li>
            <li><strong>Empowerment:</strong> Know what people like you experienced, then choose your path</li>
            <li><strong>Intellectual Honesty:</strong> Choose proven, transparent science over unfounded mysticism</li>
          </ul>
        </div>

        <div className="cta-section">
          <button className="btn-primary" onClick={() => navigate('/login')}>Harness the AI Today</button>
        </div>
      </div>

      <footer className="static-footer">
        <p>&copy; 2025 Mellodai. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PhilosophyPage;
